import {
  FETCH_USER_ROLE_REQUEST,
  FETCH_USER_ROLE_SUCCESS,
  FETCH_USER_ROLE_FAILURE,
} from './types/UserActionTypes';

export function fetchUserRoleRequestActionCreator() {
  return {
    type: FETCH_USER_ROLE_REQUEST,
  };
}

export function fetchUserRoleSuccessActionCreator(payload) {
  return {
    type: FETCH_USER_ROLE_SUCCESS,
    payload,
  };
}

export function fetchUserRoleFailureActionCreator(error) {
  return {
    type: FETCH_USER_ROLE_FAILURE,
    payload: error,
    error: true,
  };
}
